import { TaskEither, Either, left, right, taskEither } from '@shared-commons/utils';
import { CourseDataFilters, FilteredDataFilters, FilteredData } from '../types/filtered-data';
import {
  buildSeriesFilter,
  buildLearningPathsFilter,
  buildMasterclassesFilter,
} from './filter-builder';

export const getSearchFilteredData = (
  filters: Partial<CourseDataFilters>,
  page: FilteredDataFilters['page'],
  query: string,
): TaskEither<Error, FilteredData[]> => {
  const task = async (): Promise<Either<Error, FilteredData[]>> => {
    console.log('Fetching Filtered Search Catalog Data...');
    const parsedFilters: FilteredDataFilters = {
      page,
      seriesFilters: buildSeriesFilter(filters),
      learningPathFilter: buildLearningPathsFilter(filters),
      masterclassFilter: buildMasterclassesFilter(filters),
      courseType: filters.types || [],
      query,
    };

    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_HOST}/api/catalog/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(parsedFilters),
      });

      if (!response.ok) {
        let errorMessage = 'Failed to fetch filtered search data.';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch (parseError) {}
        return left(new Error(errorMessage));
      }

      const data: { data: FilteredData[] } = await response.json();

      return right(data.data);
    } catch (error: any) {
      return left(new Error(error.message || 'An unexpected error occurred.'));
    }
  };

  return taskEither<Error, FilteredData[]>(task);
};
